import { AbsgArrayHelper, EnvironmentConfiguration, LogService } from '@absg/angular-common';
import { SessionService } from '@absg/nim-client-shared';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { AnonymousContentPage } from 'shared.components/anonymous-content-page/anonymous-content-page';

import { CmsService } from '../shared/services/cms.service';

@Component({
  selector: '[nc-cms]',
  templateUrl: './cms.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsComponent extends AnonymousContentPage implements OnInit, OnDestroy {
  cmsUrlBackup = '';
  componentIsDestroyed = new Subject<void>();
  isFailedState$: Observable<boolean>;
  hasLoaded$ = new BehaviorSubject<boolean>(false);

  constructor(private sessionService: SessionService,
    private cmsService: CmsService,
    private environment: EnvironmentConfiguration,
    private logService: LogService,
  ) {
    super();
    this.cmsService.cmsUrl$.pipe(takeUntil(this.componentIsDestroyed)).subscribe(cmsUrl => {
      // log cms url see defect 108184, 108183
      this.cmsService.setFailedState(false);
       
      const logCmsUrl = `cmsService.cmsUrl Emit StationName: ${this.sessionService.stationName}, Domain: ${this.sessionService.practiceDomain} , Cms Url: ${cmsUrl}`;
      this.logService.logTrace(logCmsUrl);
      this.home(cmsUrl);
    });
    this.isFailedState$ = this.cmsService.isFailedState$;
  }
  ngOnInit(): void {
    combineLatest([this.sessionService.stationName, this.sessionService.practiceDomain])
      .pipe(takeUntil(this.componentIsDestroyed), map(([stationName, practiceDomain]) => ({
        hostname: stationName,
        domain: practiceDomain,
      })))
      .subscribe(x => {
        this.logService.logTrace(`stationname=${x.hostname}&domain=${x.domain} received`);
        if (!AbsgArrayHelper.isNil(x.hostname) && !AbsgArrayHelper.isNil(x.domain)) {
          this.cmsUrlBackup = `${this.environment.cmsUrl}?stationname=${x.hostname}&domain=${x.domain}`;

          // log cms url.  please see defect 108184, 108185
          const logCmsUrl = `ngOnInit StationName: ${x.hostname}, Domain: ${x.domain}
          ,Environment Cms Url: ${this.environment.cmsUrl}, Complete Cms Url: ${this.cmsUrlBackup}`;
          this.logService.logTrace(logCmsUrl);
          this.home(this.cmsUrlBackup);
          this.logService.logTrace('CMS Loaded Completed');
          this.sessionService.isLoginEnabled.next(true);
        }
      });
  }

  ngOnDestroy(): void {
    this.componentIsDestroyed.next();
    this.componentIsDestroyed.unsubscribe();
  }

  home(cmsUrl: string): void {
    // log cms url. please see defect 108184, 108185
    const wv = document.getElementById('contentWebview');
    if (wv !== null) {
      this.logService.logTrace(`set the cms url to ${cmsUrl}`);
      wv.setAttribute('src', cmsUrl);
    } else {
      this.logService.logTrace('Unable to render the CMS Page.  Element is null');
    }
  }

  pageLoaded(): void {
    this.hasLoaded$.next(true);
  }
}
